import { FacilityResponse } from "@/types/facility.definition";
import { SearchRequest, SearchResponse } from "../types/search.definition";
import {
  requestSearchHealthFacilities,
  searchAppointmentsInHealthcareFacility,
  searchDoctorsInHealthcareFacility,
  searchPatientsInHealthcareFacility,
} from "../webclients/search.client";

export const searchApi = {
  searchAppointmentsInFacility: async (data: SearchRequest, id: number) => {
    const response = await searchAppointmentsInHealthcareFacility(data, id);
    return response.data;
  },
  searchDoctorsInFacility: async (data: SearchRequest, id: number) => {
    const response = await searchDoctorsInHealthcareFacility(data, id);
    return response.data;
  },
  searchPatientsInFacility: async (data: SearchRequest, id: number) => {
    const response = await searchPatientsInHealthcareFacility(data, id);
    return response.data;
  },
  searchHealthFacilities: async (
    data: SearchRequest
  ): Promise<SearchResponse<FacilityResponse>> => {
    const response = await requestSearchHealthFacilities(data);
    return response.data;
  },
};
